export const IconApple = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 60 60" fill="none">
    <path
      fill="currentColor"
      d="M47.58 22.2c-.2.13-5.08 2.66-5.08 8.29.23 6.4 6.15 8.65 6.25 8.65-.1.12-.9 3.07-3.24 6.15-1.86 2.66-3.93 5.34-7.06 5.34-2.99 0-4.06-1.78-7.5-1.78-3.7 0-4.75 1.77-7.58 1.77-3.14 0-5.36-2.82-7.32-5.45a25.75 25.75 0 0 1-4.8-14.04c-.05-2.75.51-5.45 1.94-7.75a11.65 11.65 0 0 1 9.54-5.45c3.01-.1 5.69 1.93 7.53 1.93 1.76 0 5.05-1.93 8.77-1.93 1.6 0 5.9.45 8.55 4.28ZM30 17.39c-.53-2.51.94-5.03 2.32-6.63a10.04 10.04 0 0 1 6.94-3.25 9.02 9.02 0 0 1-2.55 6.77c-1.56 1.94-4.23 3.4-6.7 3.1Z"
    />
  </svg>
);
